<template>
  <div>
    <!-- Page Content -->
    <div class="content">
      <!-- Full Table -->
      <base-block rounded title="Test Question Details">
        <b-table-simple responsive bordered striped table-class="table-vcenter">
          <b-thead>
            <b-tr>
              <b-th class="text-center">S.NO</b-th>
              <b-th class="text-center">Parent Topic</b-th>
              <b-th class="text-center">Topic</b-th>
              <b-th class="text-center">Sub Topic</b-th>
              <b-th class="text-center">Question Count</b-th>
              <b-th class="text-center" v-if="type == 'default'">Action</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr>
              <b-td class="text-center">
                1
              </b-td>
              <b-td class="text-center">Topic</b-td>
              <b-td class="text-center">Topic 1</b-td>
              <b-td class="text-center">Sub Topic 1</b-td>
              <b-td class="text-center">10</b-td>
              <b-td class="text-center" v-if="type == 'default'">
                <b-button size="sm" variant="alt-primary" v-b-modal.modal-1>
                  <i class="fa fa-fw fa-eye"></i>
                </b-button>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>

        <!-- modal -->

        <b-modal
          id="modal-1"
          title="Questions"
          size="xl"
          ref="modalone"
          no-close-on-esc
          no-close-on-backdrop
          hide-footer
          @close="questionData = []"
        >
          <!-- legends -->
          <div class="col-md-12" v-if="questionData != ''">
            <dl class="float-right">
              <dt class="green"></dt>
              <dd>Fillups</dd>

              <dt class="blue"></dt>
              <dd>Group</dd>

              <dt class="grey"></dt>
              <dd>MCQ</dd>
            </dl>
            <br />
          </div>
          <!-- Questions list -->

          <div>
            <br />
            <b-list-group
              class="list-group"
              v-for="(question, index) in questionData"
              :key="index"
            >
              <b-list-group-item
                :class="
                  question.map_sub_questions.question_type == 'fill_in_blank'
                    ? 'border-warning mb-1'
                    : question.map_sub_questions.question_type == 'objective'
                    ? 'border-dark mb-1'
                    : 'border-primary mb-1'
                "
                v-html="`${ question.map_sub_questions.question }`"
              >
              </b-list-group-item>
            </b-list-group>
          </div>
          <div class="text-right mt-3" v-if="questionData.length > 0">
            <b-button variant="success" @click="Ok()">Ok</b-button>
          </div>
        </b-modal>
      </base-block>
    </div>
  </div>
</template> 

<script>
import axios from "axios";
export default {
  data() {
    return {
      parentTopic: "",
      topic: "",
      subtopic: "",
      questionCount: "",
      type: "",
      questionData: [],
    };
  },
  mounted() {
    this.getTests();
  },
  methods: {
    Ok() {
      this.$refs.modalone.hide();
      this.questionData = [];
    },
    async getTests() {
      await axios
        .get(
          `${this.$store.getters.baseUrl}/sub_practicequestionlist/${this.$route.params.subId}/${this.$route.params.testId} `,
          {
            headers: { Authorization: `Bearer ${this.$store.getters.token}` },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.parentTopic =
              response.data.mapped_topic.mapped_topic_parent.mapped_topic_belong.topic.name;
            this.topic =
              response.data.mapped_topic.mapped_topic_parent.topic.name;
            this.subtopic = response.data.mapped_topic.topic_name;
            this.questionCount = response.data.mapped_topic.no_of_questions;
            this.type = response.data.test.test_type;
            this.questionData = response.data.questions;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
      if ("MathJax" in window) {
        this.$nextTick(function () {
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () =>
            console.log("done")
          );
        });
      }
    },
  },
};
</script>

<style scoped>
dl dt {
  display: inline-block;
  width: 20px;
  height: 20px;
  vertical-align: middle;
}
dl dd {
  display: inline-block;
  margin: 0px 10px;
  padding-bottom: 0;
  vertical-align: middle;
}
dl dt.green {
  background: #e5ae67;
}
dl dt.grey {
  background: #343a40;
}
dl dt.blue {
  background: #5179d6;
}
</style>